module.exports = __webpack_public_path__ + "img/3_130.95ecf258.png";